(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1777],{

/***/ 71571:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/form-validierung",
      function () {
        return __webpack_require__(71152);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ form_validierung; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/lib/ToastHighLighter.tsx + 1 modules
var ToastHighLighter = __webpack_require__(19203);
;// CONCATENATED MODULE: ./src/components/codeHighlights/FormValidationCode.tsx


var FormValidationCode = function() {
    var language = "html";
    var codeString = '\n  // Form validation\n  <form className="row g-3 needs-validation" noValidate>\n    <div className="col-md-4">\n      <label htmlFor="validationCustom01" className="form-label">\n        First name\n      </label>\n      <input\n        type="text"\n        className="form-control"\n        id="validationCustom01"\n        required\n      />\n      <div id="emailHelp" className="form-text">\n        We\'ll never share your email with anyone else.\n      </div>\n      <div className="invalid-feedback">Please add your first name!</div>\n    </div>\n    <div className="col-md-4">\n      <label htmlFor="validationCustom02" className="form-label">\n        Last name\n      </label>\n      <input\n        type="text"\n        className="form-control"\n        id="validationCustom02"\n        required\n      />\n      <div className="valid-feedback">Looks good!</div>\n    </div>\n    <div className="col-md-4">\n      <label htmlFor="validationCustomUsername" className="form-label">\n        Username\n      </label>\n      <div className="input-group has-validation">\n        <span className="input-group-text" id="inputGroupPrepend">\n          @\n        </span>\n        <input\n          type="text"\n          className="form-control"\n          id="validationCustomUsername"\n          aria-describedby="inputGroupPrepend"\n          required\n        />\n        <div className="invalid-feedback">Please choose a username.</div>\n      </div>\n    </div>\n    <div className="col-md-6">\n      <label htmlFor="validationCustom03" className="form-label">\n        City\n      </label>\n      <input\n        type="text"\n        className="form-control"\n        id="validationCustom03"\n        required\n      />\n      <div className="invalid-feedback">Please provide a valid city.</div>\n    </div>\n    <div className="col-md-3">\n      <label htmlFor="validationCustom04" className="form-label">\n        State\n      </label>\n      <select className="form-select" id="validationCustom04" required>\n        <option defaultValue="" disabled>\n          Choose...\n        </option>\n        <option>A</option>\n        <option>B</option>\n        <option>C</option>\n      </select>\n      <div className="invalid-feedback">Please select a valid state.</div>\n    </div>\n    <div className="col-md-3">\n      <label htmlFor="validationCustom05" className="form-label">\n        Zip\n      </label>\n      <input\n        type="text"\n        className="form-control"\n        id="validationCustom05"\n        required\n      />\n      <div className="invalid-feedback">Please provide a valid zip.</div>\n    </div>\n    <div className="col-12">\n      <div className="form-check">\n        <input\n          className="form-check-input"\n          type="checkbox"\n          value=""\n          id="invalidCheck"\n          required\n        />\n        <label className="form-check-label" htmlFor="invalidCheck">\n          Agree to terms and conditions\n        </label>\n        <div className="invalid-feedback">\n          You must agree before submitting.\n        </div>\n      </div>\n      <div className="form-check mb-3">\n        <input\n          type="checkbox"\n          className="form-check-input"\n          id="validationFormCheck1"\n          required\n        />\n        <label className="form-check-label" htmlFor="validationFormCheck1">\n          Check this checkbox\n        </label>\n        <div className="invalid-feedback">\n          Example invalid feedback text\n        </div>\n      </div>\n\n      <div className="form-check">\n        <input\n          type="radio"\n          className="form-check-input"\n          id="validationFormCheck2"\n          name="radio-stacked"\n          required\n        />\n        <label className="form-check-label" htmlFor="validationFormCheck2">\n          Toggle this radio\n        </label>\n      </div>\n      <div className="form-check mb-3">\n        <input\n          type="radio"\n          className="form-check-input"\n          id="validationFormCheck3"\n          name="radio-stacked"\n          required\n        />\n        <label className="form-check-label" htmlFor="validationFormCheck3">\n          Or toggle this other radio\n        </label>\n        <div className="invalid-feedback">\n          More example invalid feedback text\n        </div>\n      </div>\n      <div className="form-check form-switch">\n        <input\n          className="form-check-input"\n          type="checkbox"\n          id="flexSwitchCheckDefault"\n          required\n        />\n        <label\n          className="form-check-label"\n          htmlFor="flexSwitchCheckDefault"\n        >\n          Default switch checkbox input\n        </label>\n      </div>\n      <div className="form-check form-switch">\n        <input\n          className="form-check-input"\n          type="checkbox"\n          id="flexSwitchCheckChecked"\n          checked\n        />\n        <label\n          className="form-check-label"\n          htmlFor="flexSwitchCheckChecked"\n        >\n          Checked switch checkbox input\n        </label>\n      </div>\n    </div>\n    <div className="col-md-6">\n      <div className="form-floating mb-3">\n        <input\n          type="email"\n          className="form-control"\n          id="floatingInput3"\n          placeholder="name@example.com"\n          required\n        />\n        <label htmlFor="floatingInput3">Email address</label>\n        <div className="valid-feedback">Looks good!!</div>\n        <div className="invalid-feedback">\n          Please enter a password. Min. 5 characters required.\n        </div>\n      </div>\n    </div>\n  <div className="col-md-6">\n    <div className="form-floating">\n      <input\n        type="password"\n        className="form-control"\n        id="floatingPassword"\n        placeholder="Password"\n        autoComplete="on"\n        required\n      />\n      <label htmlFor="floatingPassword">Password</label>\n      <div className="valid-feedback">Looks good!!</div>\n      <div className="invalid-feedback">\n        Please enter a password. Min. 5 characters required.\n      </div>\n    </div>\n  </div>\n  <div className="mb-3">\n    <label htmlFor="exampleFormControlTextarea1" className="form-label">\n      Example textarea\n    </label>\n    <textarea\n      className="form-control"\n      id="exampleFormControlTextarea1"\n      rows="3"\n      required\n    ></textarea>\n  </div>\n  <div className="col-12">\n    <button\n      id="standard-form-submit"\n      className="btn btn-secondary me-2"\n      type="submit"\n    >\n      Submit form\n    </button>\n    <button id="resetForm" className="btn btn-light" type="reset">\n      Reset form\n    </button>\n  </div>\n</form>\n  ';
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastHighLighter/* default */.Z, {
            name: "formvalidation",
            codeString: codeString,
            language: language,
            show: true
        })
    });
};
var FormValidationJSCode = function() {
    var language = "js";
    var codeString = "\n  // Form validation - Javascript example code\n  \n  (function () {\n    'use strict';\n\n    // Fetch all the forms we want to apply custom Bootstrap validation styles to\n    var forms = document.querySelectorAll('.needs-validation');\n\n    // Loop over them and prevent submission\n    Array.prototype.slice.call(forms).forEach(function (form) {\n      form.addEventListener(\n        'submit',\n        function (event) {\n          if (!form.checkValidity()) {\n            event.preventDefault();\n            event.stopPropagation();\n          }\n\n          form.classList.add('was-validated');\n        },\n        false\n      );\n    });\n  })();  \n";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastHighLighter/* default */.Z, {
            name: "formvalidationjs",
            codeString: codeString,
            language: language,
            show: true
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FormValidation.tsx



var FormValidation = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Form-Validierung"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "lead",
                children: [
                    "Dieses Formular dient als Beispiel f\xfcr die Validierung mit s\xe4mtlichen Formelementen wie ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        children: "Text"
                    }),
                    ", ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        children: "Select"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        children: "Checkboxen"
                    }),
                    ", ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        children: "Radios"
                    }),
                    " und ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        children: "Textarea"
                    }),
                    ". Das Validierungsskript ist unten aufgef\xfchrt und ist im",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "".concat("https://web.fhnw.ch/fhnw-styleguide-v5", "/download"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: "Download-Packet"
                        })
                    }),
                    " ",
                    "enthalten."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "row g-3 needs-validation",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "validationCustom01",
                                className: "form-label",
                                children: "First name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                className: "form-control",
                                id: "validationCustom01",
                                required: true,
                                onChange: function(e) {}
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "emailHelp",
                                className: "form-text",
                                children: "We'll never share your email with anyone else."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "invalid-feedback",
                                children: "Please add your first name!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "validationCustom02",
                                className: "form-label",
                                children: "Last name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                className: "form-control",
                                id: "validationCustom02",
                                required: true,
                                onChange: function(e) {}
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "valid-feedback",
                                children: "Looks good!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "validationCustomUsername",
                                className: "form-label",
                                children: "Username"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "input-group has-validation",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "input-group-text",
                                        id: "inputGroupPrepend",
                                        children: "@"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        className: "form-control",
                                        id: "validationCustomUsername",
                                        "aria-describedby": "inputGroupPrepend",
                                        required: true,
                                        onChange: function(e) {}
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "invalid-feedback",
                                        children: "Please choose a username."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "validationCustom03",
                                className: "form-label",
                                children: "City"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                className: "form-control",
                                id: "validationCustom03",
                                required: true,
                                onChange: function(e) {}
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "invalid-feedback",
                                children: "Please provide a valid city."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "validationCustom04",
                                className: "form-label",
                                children: "State"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                className: "form-select",
                                id: "validationCustom04",
                                required: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        defaultValue: "",
                                        disabled: true,
                                        children: "Choose..."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "A"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "B"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        children: "C"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "invalid-feedback",
                                children: "Please select a valid state."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "validationCustom05",
                                className: "form-label",
                                children: "Zip"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                className: "form-control",
                                id: "validationCustom05",
                                required: true,
                                onChange: function(e) {}
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "invalid-feedback",
                                children: "Please provide a valid zip."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-check",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "form-check-input",
                                        type: "checkbox",
                                        value: "",
                                        id: "invalidCheck",
                                        required: true,
                                        onChange: function(e) {}
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "invalidCheck",
                                        children: "Agree to terms and conditions"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "invalid-feedback",
                                        children: "You must agree before submitting."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-check mb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "checkbox",
                                        className: "form-check-input",
                                        id: "validationFormCheck1",
                                        required: true,
                                        onChange: function(e) {}
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "validationFormCheck1",
                                        children: "Check this checkbox"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "invalid-feedback",
                                        children: "Example invalid feedback text"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-check",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        className: "form-check-input",
                                        id: "validationFormCheck2",
                                        name: "radio-stacked",
                                        required: true,
                                        onChange: function(e) {}
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "validationFormCheck2",
                                        children: "Toggle this radio"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-check mb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        className: "form-check-input",
                                        id: "validationFormCheck3",
                                        name: "radio-stacked",
                                        required: true,
                                        onChange: function(e) {}
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "validationFormCheck3",
                                        children: "Or toggle this other radio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "invalid-feedback",
                                        children: "More example invalid feedback text"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-check form-switch",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "form-check-input",
                                        type: "checkbox",
                                        id: "flexSwitchCheckDefault",
                                        required: true,
                                        onChange: function(e) {}
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "flexSwitchCheckDefault",
                                        children: "Default switch checkbox input"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-check form-switch",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: "form-check-input",
                                        type: "checkbox",
                                        id: "flexSwitchCheckChecked",
                                        checked: true,
                                        onChange: function(e) {}
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "form-check-label",
                                        htmlFor: "flexSwitchCheckChecked",
                                        children: "Checked switch checkbox input"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-floating mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "email",
                                    className: "form-control",
                                    id: "floatingInput3",
                                    placeholder: "name@example.com",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "floatingInput3",
                                    children: "Email address"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "valid-feedback",
                                    children: "Looks good!!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "invalid-feedback",
                                    children: "Please enter a password. Min. 5 characters required."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-floating",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "password",
                                    className: "form-control",
                                    id: "floatingPassword",
                                    placeholder: "Password",
                                    autoComplete: "on",
                                    required: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "floatingPassword",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "valid-feedback",
                                    children: "Looks good!!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "invalid-feedback",
                                    children: "Please enter a password. Min. 5 characters required."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "exampleFormControlTextarea1",
                                className: "form-label",
                                children: "Example textarea"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                className: "form-control",
                                id: "exampleFormControlTextarea1",
                                rows: 3,
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn btn-secondary me-2",
                                type: "submit",
                                children: "Submit form"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                id: "resetForm",
                                className: "btn btn-light",
                                type: "reset",
                                children: "Reset form"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormValidationCode, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormValidationJSCode, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FormValidation = (FormValidation);

// EXTERNAL MODULE: ./src/lib/helpers.tsx
var helpers = __webpack_require__(62670);
;// CONCATENATED MODULE: ./pages/basic-elements/form-validierung.tsx




var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Formularvalidierung",
                description: "Basiselemente - Plausibilit\xe4tspr\xfcfungen der Formulare realisiert mit Bootstrap 5 und Vanilla-Javascript.",
                canonical: "".concat("https://web.fhnw.ch/fhnw-styleguide-v5").concat((0,helpers/* GetPathName */.R)())
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FormValidation, {})
        ]
    });
};
/* harmony default export */ var form_validierung = (Page);


/***/ }),

/***/ 19203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_ToastHighLighter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/esm/prism.js + 15 modules
var prism = __webpack_require__(5227);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/cjs/styles/prism/index.js
var styles_prism = __webpack_require__(84283);
;// CONCATENATED MODULE: ./src/lib/HighLighter.tsx



var CodeHighLight = function(param) {
    var codeString = param.codeString, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(prism/* default */.Z, {
        language: language,
        wrapLines: true,
        showLineNumbers: true,
        style: styles_prism/* dracula */.cL,
        children: codeString
    });
};
/* harmony default export */ var HighLighter = (CodeHighLight);

// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/lib/ToastHighLighter.tsx




var ToastHighLighter = function(param) {
    var name = param.name, codeString = param.codeString, language = param.language, show = param.show, _disableCopy = param.disableCopy, disableCopy = _disableCopy === void 0 ? false : _disableCopy;
    var ref = (0,react.useState)(false), state = ref[0], setState = ref[1];
    var handleClick = function() {
        setState(true);
        setTimeout(function() {
            setState(false);
        }, 5000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "btn btn-light btn-sm text-uppercase",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#".concat(name),
                "aria-expanded": "".concat(show ? "true" : "false"),
                "aria-controls": name,
                children: language
            }),
            disableCopy === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: codeString,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "btn btn-info btn-sm",
                    onClick: handleClick,
                    children: "Code kopieren"
                })
            }) : false,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collapse ".concat(show ? "show" : false),
                id: name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card card-body highlighter",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighLighter, {
                        codeString: codeString,
                        language: language
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "position-fixed top-0 end-0 p-3",
                style: {
                    zIndex: 1100
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "liveToast",
                    className: "toast ".concat(state ? "show" : "hide"),
                    role: "alert",
                    "aria-live": "assertive",
                    "aria-atomic": "true",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "toast-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "me-auto",
                                    children: "Code copied to clipboard"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn-close",
                                    "data-bs-dismiss": "toast",
                                    "aria-label": "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "toast-body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighLighter, {
                                codeString: codeString,
                                language: language
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var lib_ToastHighLighter = (ToastHighLighter);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,5063,9774,2888,179], function() { return __webpack_exec__(71571); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);